import { render, staticRenderFns } from "./MQService.vue?vue&type=template&id=57ba5134&scoped=true&"
import script from "./MQService.vue?vue&type=script&lang=js&"
export * from "./MQService.vue?vue&type=script&lang=js&"
import style0 from "./MQService.vue?vue&type=style&index=0&id=57ba5134&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ba5134",
  null
  
)

export default component.exports